import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MaterialGrid from '@material-ui/core/Grid';
import LoadingProgress from 'common/components/progress/loading';
import _ from 'lodash';
import AlertDialogSlide from 'common/components/dialog/dialogActivities';
import Informations from 'modules/owner/pages/actions/sections/information';
import ActionsTabs from 'common/components/navigation/actionsTab/activityTabs';
import Interaction from './sections/interaction';
import Prize from 'modules/owner/pages/actions/sections/prize';
import Publish from 'modules/owner/pages/actions/sections/publish';
import {
  submitAction,
  getDetail,
  dispatchFormReset,
  savePartialy,
} from './videoPlaylistActions';
import { getFormValues } from 'redux-form';
import { imgToBase64, imgToImgType } from 'helpers/utils';
import { isMobile } from 'react-device-detect';
import { publishAction } from 'modules/owner/pages/actions/activeActions/activeActionsScripts';

function Main(props) {
  const [value, setValue] = React.useState(0);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  async function handleChange(values, router) {
    values.base64 = values.image.base64;
    if (!_.isUndefined(values.image.base64)) {
      values.imageType = imgToImgType(values.image);
    }

    values['type_action'] = 18;

    values.body = {
      ...values,
      name: values.body_name,
      description: values.body_description,
    };
    delete values.body['image'];
    delete values.body['base64'];
    delete values.body['imageType'];
    values.body = JSON.stringify(values.body);

    let selectedVideos = [];
    if (values.videosAdd) {
      for (let i in values.videosAdd) {
        selectedVideos.push({
          video_id: values.videosAdd[i].id,
          name: values.videosAdd[i].name,
          description: values.videosAdd[i].description,
          required: values.videosAdd[i].required,
        });
      }
    }

    values.videos = [...selectedVideos];

    props.savePartialy(values, router, setValue, value);
  }

  function goBack() {
    setValue(value - 1);
  }

  function handleOpenConfirmation() {
    setOpenConfirmation(true);
  }
  function handleCancelClose() {
    setOpenConfirmation(false);
  }

  function handleNativeChange(e, newValue) {
    if (
      props.router.params.action === 'editar' ||
      props.router.params.action === 'rascunho' ||
      props.router.params.action === 'proposta'
    ) {
      setValue(newValue);
    } else {
      if (newValue < value) {
        setValue(newValue);
      }
    }
  }

  useEffect(() => {
    if (
      props.router.params.action === 'editar' ||
      props.router.params.action === 'rascunho' ||
      props.router.params.action === 'proposta'
    ) {
      props.getDetail(props.router.params.id);
    }
  }, []);

  const onSubmit = async values => {
    if (!_.isUndefined(values.image.base64)) {
      values.imageType = imgToImgType(values.image);
      values.base64 = imgToBase64(values.image);
    }

    if (values.featuredPrivate) {
      if (!_.isUndefined(values.featuredImage.base64)) {
        values.featuredImage.imageType = imgToImgType(values.featuredImage);
      }
    }

    const target = {
      age: {
        from: values.from,
        to: values.to,
      },
      states: values.states,
      associated: values.associated,
      internal: values.internal,
    };
    values['stations'] = [values.stationId];
    values['partner'] = props.auth.user.establishments[0].id;
    values['type_action'] = 18;
    values['sponsored'] = true;

    values['target'] = target;
    const create_or_update =
      props.router.params.action === 'editar' ||
        props.router.params.action === 'rascunho'
        ? 'update'
        : 'create';
    const id_action = props.router.params.id;
    let publish = null;
    if (props.router.params.action === 'rascunho') {
      publish = () => {
        return props.publishAction(
          props.router.params.id,
          values.stationId,
          'videoPlaylistForm',
          props.router,
          values.message_to_owner,
          'PRODUCT_DELIVERIES_BUTTON_LOAD'
        );
      };
    }

    props.submitAction(
      values,
      props.router,
      create_or_update,
      id_action,
      publish
    );
  };

  function onDialogClose() {
    props.dispatchFormReset();
    const from = props.location.query.from
      ? props.location.query.from
      : 'online';
    props.router.push(
      props.router.params.action === 'editar'
        ? `/owner/acoes/minhas-atividades?from=${from}`
        : props.router.params.action === 'rascunho'
          ? '/owner/acoes/minhas-atividades?from=drafts'
          : props.router.params.action === 'proposta'
            ? '/owner/acoes/propostas'
            : '/owner'
    );
  }

  return (
    <AlertDialogSlide
      label={'Video Playlist'}
      value={value}
      test={true}
      visible={true}
      height="95vh"
      form={props.formValues}
      onClose={handleOpenConfirmation}
      maxWidth={isMobile ? 'xl' : 'sm'}
    >
      {props.videoPlaylist.loading ? (
        <div className="d-flex justify-content-center mt-5">
          <LoadingProgress />
        </div>
      ) : (
        <MaterialGrid
          container
          direction="column"
          justify="center"
          alignItems="stretch"
          sm={12}
          md={12}
          lg={12}
        >
          <ActionsTabs
            styles={{ marginBottom: 35, width: '100%' }}
            icons={[1, 2, 0, 0]}
            sectionTitles={[0, 2, 1, 0]}
            handleChange={handleNativeChange}
            onClickProgress={values => {
              if (values.submitFromButton) {
                return;
              }
              handleChange(values, props.router);
            }}
            goBack={goBack}
            activeTab={value}
            form="videoPlaylistForm"
            tabs={[
              {
                content: (
                  <Informations
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    template={props.location.query.template}
                    type={props.location.query.type}
                    router={props.router}
                    disabled={props.router.params.action === 'editar'}
                    form="videoPlaylistForm"
                    onClickProgress={values =>
                      handleChange(values, props.router)
                    }
                  />
                ),
                icon: 'subject',
                label: 'Informações',
              },
              {
                content: (
                  <Interaction
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    onClickProgress={values =>
                      handleChange(values, props.router)
                    }
                    prevClick={goBack}
                    router={props.router}
                  />
                ),
                icon: 'forum',
                label: 'Interações',
              },
              {
                content: (
                  <Prize
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    router={props.router}
                    onClickProgress={values =>
                      handleChange(values, props.router)
                    }
                    prevClick={goBack}
                    disabled={props.router.params.action === 'editar'}
                    form="videoPlaylistForm"
                  />
                ),
                label: 'Recompensas',
                icon: 'loyalty',
              },
              {
                content: (
                  <Publish
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    router={props.router}
                    onClickProgress={values => onSubmit(values)}
                    form="videoPlaylistForm"
                    prevClick={goBack}
                    disabled={props.router.params.action === 'editar'}
                  />
                ),
                label: 'Publicação',
                icon: 'settings',
              },
            ]}
          ></ActionsTabs>
        </MaterialGrid>
      )}
    </AlertDialogSlide>
  );
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    contacts: state.contacts,
    videoPlaylist: state.videoPlaylist,
    formValues: getFormValues('videoPlaylistForm')(state),
  };
};
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      submitAction,
      getDetail,
      dispatchFormReset,
      savePartialy,
      publishAction,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
